// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1__mo","cls2":"shared-cls2_Mar shared-cls1__mo"};